var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnlybody(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "onlybody",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 114.455,
    height: 32.027,
    viewBox: "0 0 114.455 32.027",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 114.455,
    height: 32.027,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M114.239,20.4a10.314,10.314,0,0,0-2-3.4L111.18,9.917a.5.5,0,0,0-.423-.42l-9.246-1.321c-1.123-.49-13.688-5.945-20-7.238A90.731,90.731,0,0,0,66.367,0C59.24,0,52.9.4,50.2,1.022,44.927,2.241,30.084,9.537,28.79,10.175c-1.613.251-21.39,3.337-23.432,3.91-2.133.6-3.848,4.7-4.194,5.588A3.276,3.276,0,0,0,.006,22.166c.08,1.223.246,7.4.248,7.464a.5.5,0,0,0,.428.481l9.895,1.413.063,0,.254.005H10.9a.5.5,0,0,0,.5-.5V28.013a.409.409,0,0,0,.024-.151v-.074c0-.027,0-.055,0-.083A8.786,8.786,0,0,1,29,27.7c0,.027,0,.055,0,.081l0,.076a.541.541,0,0,0,.025.165V31.36a.5.5,0,0,0,.491.5l.176,0,50.067.167h0a.224.224,0,0,0,.036,0l.129-.009a.5.5,0,0,0,.463-.5V28.527a.444.444,0,0,0,.026-.166v-.074c0-.027,0-.054,0-.083a8.785,8.785,0,1,1,17.571,0c0,.027,0,.053,0,.078l0,.079a.5.5,0,0,0,.025.164V30.2a.5.5,0,0,0,.5.5h.033l.051,0a.327.327,0,0,0,.044,0l12.64-2a.5.5,0,0,0,.33-.2l2.245-3.16a.534.534,0,0,0,.064-.126,9.161,9.161,0,0,0,.337-4.8M51.146,3.213a38.21,38.21,0,0,1,8.757-.98v9.3l-26.345.785s8.659-6.335,17.588-9.106m13.868,8.169V2.225a55.038,55.038,0,0,1,11.08,1.113c4.989,1.373,11.849,7.36,11.849,7.36Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlybody);
export default __webpack_public_path__ + "static/media/onlybody.3a4c51a38007d1fa4051c0346ce76b36.svg";
export { ForwardRef as ReactComponent };